import { AUFTRAG_API } from '@Constants/backendConstants';
import { useListApi, withCondition } from '@Hooks/useListApi';
import type { ApiStorageTransaction } from '@Model';
import { StorageTransactionsRepository } from '@Repositories/Auftragsbearbeitung';
import { EnumOperation, type ListRequest } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { type OpenViewOptions, useOpenStorageTransaction } from './useOpenStorageTransaction';

const REVERSES_COLUMN = 'reverses_transaction_id';

const counterBookingRequest = (originalId: string): ListRequest =>
    withCondition(
        { page_no: 0, page_size: 1, full_text_search: '', sort_columns: [] },
        { field: REVERSES_COLUMN, value: originalId, operator: EnumOperation.Equal },
    );

/** Opens the booking on the other side of a cancellation: the counter booking of a cancelled booking, the original of a counter booking. */
// @ai-generated 2026-10-26T15:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useOpenRelatedBooking() {
    const { openView } = useOpenStorageTransaction();
    const module = useListApi(StorageTransactionsRepository, AUFTRAG_API);

    return useCallback(
        async (booking: Pick<ApiStorageTransaction, 'id' | 'reverses_transaction_id'>, options?: OpenViewOptions) => {
            if (booking.reverses_transaction_id) {
                openView(booking.reverses_transaction_id, options);
                return;
            }

            const page = await module.loadPage(counterBookingRequest(booking.id));
            const counter = page.items[0];
            if (counter) {
                openView(counter.id, options);
            }
        },
        [module, openView],
    );
}
